import { Route } from 'react-router-dom';
import { WaitlistOffer } from './WaitlistOffer';

export const waitlistRoutes = [
  <Route
    key="waitlist-offer"
    path="/waitlist/:token/offer/:backfillId"
    element={<WaitlistOffer />}
  />,
];

export { WaitlistOffer };
